(function () {
  'use strict';
  var root = document.querySelector('[data-black-balloons]');
  if (!root || root.dataset.ready || !Element.prototype.animate) return;
  root.dataset.ready = 'true';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var timers = new Set(), animations = new Set(), active = false, destroyed = false;
  var visible = new Set(), seen = new WeakSet(), currentTarget = null, observer;
  var stage = root, dialogStage = null;
  var offers = (root.dataset.offers || '').split('|').map(function (offer) { return offer.split('~'); });
  if (offers.length < 3) return;
  function later(fn, delay) {
    var timer = window.setTimeout(function () { timers.delete(timer); fn(); }, delay);
    timers.add(timer);
    return timer;
  }
  function animate(node, frames, options, done) {
    var animation = node.animate(frames, options);
    animations.add(animation);
    animation.finished.then(function () {
      animations.delete(animation);
      if (done && !destroyed) done();
    }).catch(function () { animations.delete(animation); });
    return animation;
  }
  function clear() {
    timers.forEach(function (timer) { window.clearTimeout(timer); });
    timers.clear();
    animations.forEach(function (animation) { animation.cancel(); });
    animations.clear();
    root.replaceChildren();
    root.dataset.running = 'false';
    root.classList.remove('tb-bf-fx--purchase');
    if (dialogStage) { dialogStage.remove(); dialogStage = null; }
    stage = root;
    currentTarget = null;
    active = false;
  }
  function amount(node) {
    var match = node && node.textContent.match(/R\$\s*[\d.]+(?:,\d{2})?/);
    return match && /[1-9]/.test(match[0]) ? match[0].replace(/\s+/g, ' ') : '';
  }
  function eligible(node) {
    if (!node || !node.isConnected || node.closest('[hidden]')) return false;
    var bounds = node.getBoundingClientRect();
    var modal = document.querySelector('dialog[open],#mini-cart[open]');
    return bounds.width > 0 && bounds.height > 0 && bounds.bottom > 100 && bounds.top < window.innerHeight * .85 && (!modal || modal.contains(node));
  }
  function label(node) {
    var container = node.closest('article,section,dialog');
    var heading = container && container.querySelector('h3,.pt,h2');
    return heading ? heading.textContent.trim().replace(/\s+/g, ' ') : root.dataset.selection;
  }
  function finish() { clear(); drain(); }
  function useDialog(dialog) {
    dialogStage = document.createElement('div');
    dialogStage.className = 'tb-bf-fx tb-bf-fx--dialog';
    dialogStage.setAttribute('aria-hidden', 'true');
    dialog.appendChild(dialogStage); stage = dialogStage;
  }
  function pop(balloon, x, y, offer, small) {
    if (!active || reduced.matches || document.hidden) return;
    balloon.remove();
    var fragments = small ? 5 : 7;
    for (var i = 0; i < fragments; i++) {
      var bit = document.createElement('span');
      bit.className = 'tb-bf-fragment';
      bit.style.left = x + 'px'; bit.style.top = y + 'px';
      stage.appendChild(bit);
      var angle = (i / fragments) * Math.PI * 2, radius = small ? 48 : 70;
      animate(bit, [
        { transform: 'translate(-50%,-50%) rotate(' + (i * 42) + 'deg)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + (Math.cos(angle) * radius) + 'px),calc(-50% + ' + (Math.sin(angle) * radius + 22) + 'px)) rotate(' + (i * 42 + 140) + 'deg) scale(.5)', opacity: 0 }
      ], { duration: 430, easing: 'cubic-bezier(.16,1,.3,1)', fill: 'both' }, function () { this.remove(); }.bind(bit));
    }
    var chip = document.createElement('span');
    chip.className = 'tb-bf-discount';
    var chipWidth = small ? 144 : 164;
    chip.style.left = Math.max(chipWidth / 2 + 14, Math.min(stage.clientWidth - chipWidth / 2 - 14, x)) + 'px';
    chip.style.top = y + 'px';
    ['small', 'strong', 'small'].forEach(function (tag, index) {
      var line = document.createElement(tag); line.textContent = offer[index] || ''; chip.appendChild(line);
    });
    stage.appendChild(chip);
    animate(chip, [
      { transform: 'translate(-50%,-40%) scale(.94)', opacity: 0, offset: 0 },
      { transform: 'translate(-50%,-50%) scale(1)', opacity: 1, offset: .18 },
      { transform: 'translate(-50%,-53%) scale(1)', opacity: 1, offset: .76 },
      { transform: 'translate(-50%,-65%) scale(.98)', opacity: 0, offset: 1 }
    ], { duration: 1700, easing: 'cubic-bezier(.22,1,.36,1)', fill: 'both' }, function () { chip.remove(); });
  }
  function drop(index, small, offer, origin) {
    if (!active || reduced.matches || document.hidden) return;
    var width = stage.clientWidth, height = stage.clientHeight;
    var positions = small ? [.15, .85] : [.12, .88, .67];
    var centerX = origin ? Math.max(88, Math.min(width - 88, origin.x)) : width * positions[index], size = small ? 58 : 76;
    var finishY = Math.min(height - 160, Math.max(170, height * (.35 + index * .13)));
    if (origin) finishY = Math.max(150, Math.min(height * .48, origin.y - 150));
    var balloon = document.createElement('span');
    balloon.className = 'tb-bf-balloon';
    balloon.style.left = (centerX - size / 2) + 'px';
    balloon.style.width = size + 'px';
    var body = document.createElement('span'); body.className = 'tb-bf-balloon__body'; body.textContent = '%';
    var string = document.createElement('span'); string.className = 'tb-bf-balloon__string';
    balloon.append(body, string); stage.appendChild(balloon);
    var drift = index % 2 ? -12 : 12;
    var falling = [
      { transform: 'translate3d(0,-150px,0) rotate(-9deg)', opacity: 0, offset: 0 },
      { transform: 'translate3d(' + drift + 'px,' + (finishY * .15) + 'px,0) rotate(7deg)', opacity: 1, offset: .3 },
      { transform: 'translate3d(' + (-drift) + 'px,' + (finishY * .62) + 'px,0) rotate(-6deg)', opacity: 1, offset: .7 },
      { transform: 'translate3d(0,' + (finishY - size * .6) + 'px,0) rotate(4deg)', opacity: 1, offset: 1 }
    ];
    var rising = origin && [
      { transform: 'translate3d(' + (origin.x - centerX) + 'px,' + (origin.y - size * .6) + 'px,0) scale(.94) rotate(-6deg)', opacity: 0, offset: 0 },
      { transform: 'translate3d(' + (origin.x - centerX) * .6 + 'px,' + ((origin.y + finishY) / 2 - size * .6) + 'px,0) scale(1) rotate(7deg)', opacity: 1, offset: .35 },
      { transform: 'translate3d(0,' + (finishY - size * .6) + 'px,0) rotate(-4deg)', opacity: 1, offset: 1 }
    ];
    animate(balloon, origin ? rising : falling, { duration: origin ? 1050 : 1550 + index * 70, easing: 'cubic-bezier(.32,.02,.65,1)', fill: 'forwards' }, function () {
      if (currentTarget && !eligible(currentTarget)) { finish(); return; }
      pop(balloon, centerX, finishY, currentTarget ? [label(currentTarget), amount(currentTarget), root.dataset.saving] : offer, small);
    });
  }
  function wave(phase, target, origin, purchaseOffer) {
    if (active || destroyed || reduced.matches || document.hidden) return false;
    if (!target && !origin && document.querySelector('dialog[open],#mini-cart[open]')) return false;
    if (target && (!eligible(target) || !amount(target))) return false;
    if (target) {
      currentTarget = target;
      var dialog = target.closest('dialog[open]');
      if (dialog) useDialog(dialog);
    }
    active = true; root.dataset.running = 'true'; root.dataset.wave = phase;
    if (origin) root.classList.add('tb-bf-fx--purchase');
    var small = window.innerWidth < 768, count = target || origin ? 1 : (small ? 2 : 3);
    for (var i = 0; i < count; i++) {
      var offer = purchaseOffer || (target ? [label(target), amount(target), root.dataset.saving] : offers[i % offers.length]);
      later(drop.bind(null, i, small, offer, origin), i * 500);
    }
    later(finish, target || origin ? 3500 : 4600);
    return true;
  }
  function drain() {
    if (active || reduced.matches || document.hidden || destroyed) return;
    visible.forEach(function (node) {
      if (!active && !seen.has(node) && eligible(node) && wave('offer', node)) seen.add(node);
    });
  }
  function visibility() { if (document.hidden) clear(); }
  function preference() { if (reduced.matches) clear(); }
  document.addEventListener('visibilitychange', visibility);
  document.addEventListener('cart:refresh', function () { if (root.dataset.wave !== 'purchase') clear(); });
  document.addEventListener('pointerdown', function (event) {
    if (event.target.closest('[data-kit-add],[data-single-buy],[data-single-yes],[data-single-no],[data-single-close],[data-add],[name="checkout"],a[href*="/cart"]')) clear();
  }, { passive: true });
  document.addEventListener('takebag:savings-added', function (event) {
    if (destroyed || reduced.matches || document.hidden) return;
    var detail = event.detail || {}, value = amount({textContent: detail.saving || ''});
    if (!value || !detail.origin) return;
    clear();
    var origin = {x: detail.origin.x, y: detail.origin.y};
    var dialog = document.querySelector('dialog[open]');
    if (dialog) { useDialog(dialog); var rect = stage.getBoundingClientRect(); origin.x -= rect.left; origin.y -= rect.top; }
    wave('purchase', null, origin, [detail.preview ? root.dataset.selection : root.dataset.saved, value, root.dataset.saving]);
  });
  if (reduced.addEventListener) reduced.addEventListener('change', preference);
  else reduced.addListener(preference);
  window.addEventListener('pagehide', clear);
  if (!reduced.matches) later(function () { if (window.scrollY < window.innerHeight * .6) wave('hero'); }, 450);
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) visible.add(entry.target);
        else { visible.delete(entry.target); if (currentTarget === entry.target) clear(); }
      });
      drain();
    }, { rootMargin: '-100px 0px -15% 0px', threshold: .5 });
    document.querySelectorAll('[data-single-saving],[data-combo-saving],[data-single-combo-saving],.tb-card-saving,.tkb-black-saving').forEach(function (node) { observer.observe(node); });
  }
  document.addEventListener('shopify:section:unload', function (event) {
    if (event.target.contains(root)) { destroyed = true; clear(); if (observer) observer.disconnect(); }
  });
})();
